import { createSelector } from 'reselect';

const userSelector = state => state.user;

const createUserSelector = createSelector(userSelector, userdata => userdata);

export default createUserSelector;